/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { Text } from "vr-react-components";
import React from "react";
import { BackgroundPanel } from "vr-react-components";

const JobRoomWorkstationTooltip = ({
    element,
    width,
    height,
    textSizeDecimal,
    ...otherAttributes
}) => {
    let left = ["Name:", "Type:", "Limit:", "Running Jobs:", "Status:", "Job Ready:"];
    let right = [
        element.name,
        element.type || "",
        element.limit || "0",
        element.runningJobs.toString(),
        element.status || "Linked",
        element.jobReady.toString(),
    ];

    const generateText = () => {
        const rows = left.length;
        const rowHeight = (height * 0.75) / rows;
        
        return left.map((e, i) => {
            return (
                <a-entity key={i}>
                    <Text
                        width={width * 0.7}
                        sizeDecimal={textSizeDecimal ? textSizeDecimal : 20 / height}
                        text={left[i]}
                        align="left"
                        baseline="bottom"
                        position={`0 ${-height * 0.2 - i * rowHeight} 0`}
                    />
                    <Text
                        width={width * 0.6}
                        sizeDecimal={textSizeDecimal ? textSizeDecimal : 20 / height}
                        text={String(right[i])}
                        baseline="bottom"
                        align="right"
                        position={`${width * 0.9} ${-height * 0.2 - i * rowHeight} 0`}
                    />
                    <a-entity
                        line={`start:${0} ${-height * 0.2 - i * rowHeight} 0;end:${
                            width * 0.9
                        } ${-height * 0.2 - i * rowHeight} 0;color:#c6c6c6;opacity:0.5`}
                    />
                </a-entity>
            );
        });
    };

    return (
        <BackgroundPanel width={width} height={height} opacity={1} {...otherAttributes}>
            <a-entity
                position={`${(-width / 2) * 0.9} ${height / 2 - height / 10} 0.001 `}
            >
                <Text
                    width={width * 0.9}
                    sizeDecimal={textSizeDecimal * 0.8}
                    text="Workstation properties"
                    baseline="top"
                />
                {generateText()}
            </a-entity>
        </BackgroundPanel>
    );
};

export default JobRoomWorkstationTooltip;
